module.exports = __webpack_public_path__ + "static/media/AB_figures_mobile_reseller.dce4e28e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_figures_mobile_reseller.png
// module id = 264
// module chunks = 0